var map = {
	"./Breadcrumb/breadcrumb.html": 13978,
	"./Footer/footer.html": 68434,
	"./Headers/Templates/header_new.html": 566,
	"./ReturnsButton/returnsButton.html": 38322,
	"./ReturnsHelpTooltip/returnsHelpTooltip.html": 7954,
	"./Spinner/spinner.html": 40810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21244;